import { render, staticRenderFns } from "./WidgetMetric.vue?vue&type=template&id=4ad98962&"
import script from "./WidgetMetric.vue?vue&type=script&lang=js&"
export * from "./WidgetMetric.vue?vue&type=script&lang=js&"
import style0 from "./WidgetMetric.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports